import { render, staticRenderFns } from "./LongHaul.vue?vue&type=template&id=470ba020&scoped=true&"
import script from "./LongHaul.vue?vue&type=script&lang=js&"
export * from "./LongHaul.vue?vue&type=script&lang=js&"
import style0 from "./LongHaul.vue?vue&type=style&index=0&id=470ba020&prod&lang=css&"
import style1 from "./LongHaul.vue?vue&type=style&index=1&id=470ba020&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470ba020",
  null
  
)

export default component.exports